var imgs = document.querySelectorAll(".hero-bg-img");
var dots = document.querySelectorAll<HTMLElement>(".hero-bg-dot");
var heds = document.querySelectorAll(".hero-h");
var label = document.getElementById("hero-strain-name");
var names = ["White Runtz", "Wedding Cake", "Lust", "Beef Cake"];
var idx = 0,
  n = imgs.length,
  auto: ReturnType<typeof setInterval>;
function show(i: number) {
  imgs.forEach(function (im, k) {
    im.classList.toggle("is-active", k === i);
  });
  dots.forEach(function (d, k) {
    d.classList.toggle("is-active", k === i);
  });
  heds.forEach(function (h, k) {
    h.classList.toggle("is-active", k === i);
  });
  if (label) label.textContent = names[i];
  idx = i;
}
function next() {
  show((idx + 1) % n);
}
dots.forEach(function (d) {
  d.addEventListener("click", function () {
    show(Number(d.dataset.i));
    clearInterval(auto);
    auto = setInterval(next, 6500);
  });
});
auto = setInterval(next, 6500);